import { Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import { PTC_ERROR_MESSAGE } from '@/constants/Srp'
import useSrpRevampExperiment from '@/hooks/srp/useSrpRevampExperiment'
import { isEmpty } from '@/utils/general/browserHelper'

interface PtcErrorProps {
  showPtcError: boolean
  className?: string
  cards: any
}

const PtcError = ({ showPtcError, className = '', cards }: PtcErrorProps) => {
  const { isSrpRevamp } = useSrpRevampExperiment()

  if (isSrpRevamp || !showPtcError || isEmpty(cards)) {
    return null
  }
  return (
    <Typography className={className} variant='HM3'>
      {PTC_ERROR_MESSAGE}
    </Typography>
  )
}

export default PtcError
